'use client';

import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import { FC, PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export const LivePreviewProvider: FC<Props> = ({ children }) => {
	return (
		<ContentfulLivePreviewProvider locale="en-US">
			{children}
		</ContentfulLivePreviewProvider>
	);
};
